(function (angular) {
    'use strict';

    function prettyDate(isoDateString, withTime){

        if (!isoDateString) {
            return "";
        }

        var daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        function addZero(value) {
            return ("0" + value).slice(-2);
        }
        var date = new Date(isoDateString),
            diff = (((new Date()).getTime() - date.getTime()) / 1000),
            day_diff = Math.floor(diff / 86400);
        if (isNaN(day_diff) || day_diff < 0)
            return "just now";

        return day_diff === 0 && (
            // < 5 mons
            diff < 300 && "just now" ||
            // < 1 hour
            diff < 3600 && Math.floor(diff / 60) + " minutes ago" ||
            // same day
            diff < 7200 && "1 hour ago" ||
            diff < 86400 && Math.floor(diff / 3600) + " hours ago") ||
            // yesterday
            day_diff == 1 && "Yesterday" ||
            // < 7 days ago
            day_diff < 7 && daysOfWeek[date.getDay()] ||
            // >= 7 days ago
            day_diff >= 7 && (withTime ? addZero(date.getDate()) + "/" + addZero(date.getMonth() + 1) + "/" + date.getFullYear() + " " + (date.getHours() + 1) + ":" + date.getMinutes() : addZero(date.getDate()) + "/" + addZero(date.getMonth() + 1) + "/" + date.getFullYear());

    }

    angular.module('Common')
        /**
         *
         */
        .filter('prettyJson', function () {
            return function (input) {
                return JSON.stringify(input, null, 4);
            };
        })
        /**
         *
         */
        .filter('separateByCapital', function () {
            return function (input) {
                return input.split(/(?=[A-Z])/).join(" ");
            };
        })
        .filter('percentage', ['$filter', function ($filter) {
            return function (input, decimals) {
                return $filter('number')(input * 100, decimals) + '%';
            };
        }])
        .filter('toFullCountryName', ["sharedDataService", function (sharedDataService) {
            return function (country) {
                if (sharedDataService.getCountries()) {
                    var countries = sharedDataService.getCountries();
                    for (var i in countries) {
                        if (countries[i].code == country) {
                            return countries[i].name;
                        }

                    }
                }
                return country;
            };
        }])
        .filter('prettyDate', function () {
            return prettyDate;
        })
        .filter('prettyIfDate', function () {
            return function (isoDateString, withTime) {
                var isIso = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d)/.test(isoDateString);
                if (!isIso) {
                    return isoDateString;
                }
                
                return prettyDate(isoDateString, withTime);
            };
        })
        /**
         * 
         */
        .filter('trustAsHtml', ["$sce", function ($sce) {
            return $sce.trustAsHtml;
        }])
        .filter("betweenDates", function () {
            return function (items, by, from, to) {
                if (typeof from == 'undefined' || typeof to == 'undefined' || from === null || to === null) {
                    return items;
                }
                var df = new Date(from);
                var dt = new Date(to);
                df.setHours(0, 0, 0, 0);
                dt.setHours(23, 59, 59);
                var result = [];
                for (var i = 0; i < items.length; i++) {
                    var tf = new Date(items[i][by]),
                        tt = new Date(items[i][by]);
                    if (tf > df && tt < dt) {
                        result.push(items[i]);
                    }
                }
                return result;
            };
        })
        .filter("contains", function () {
            return function (array1, path1, array2, path2) {
                var splitedPath1 = path1.split('.');
                var splitedPath2 = path2 ? path2.split('.') : [];
                return array1.filter(function (item) {
                    var newItem = item;
                    for (var i in splitedPath1) {
                        newItem = newItem[splitedPath1[i]];
                        if (!newItem) {
                            return false;
                        }
                    }
                    for (var j in newItem) {
                        for (var k in array2) {
                            var newArray2 = array2[k];
                            for (var i in splitedPath2) {
                                newArray2 = newArray2[splitedPath2[i]];
                                if (!newArray2) {
                                    return false;
                                }
                            }
                            if (newArray2.indexOf(newItem[j]) != -1) {
                                return true;
                            }

                        }
                    }
                    return false;
                });
            };
        })
        .filter("range", function () {
            return function (arr, min, max) {
                if (!max) {
                    max = min;
                    min = 0;
                }
                min = parseInt(min);
                max = parseInt(max);
                for (var i = min; i <= max; i++) {
                    arr.push(i);
                }
                return arr;
            };
        })
        /**
        Transform a string to title case.
        Usage:
        {{ myString | titleCase }} 
        */
        .filter("titleCase", function () {
            return function (str) {
                return str
                    .toLowerCase()
                    .split(' ')
                    .map(function (word) {
                        return word[0].toUpperCase() + word.substr(1);
                    })
                    .join(' ');
            }
        })
        /**
        Transform a string to title case.
        Usage:
        {{ myString | titleCase }} 
        */
        .filter("formatSeconds", function () {
            return function (totalSeconds) {

                var hours = Math.floor(totalSeconds / 3600);
                totalSeconds %= 3600;
                var minutes = Math.floor(totalSeconds / 60);
                var seconds = totalSeconds % 60;

                var formatted = "";

                if (hours) {
                    formatted += (hours + "h ");
                }

                if (minutes) {
                    formatted += (minutes + "m ");
                }

                formatted += (seconds + "s");


                return formatted;
            }
        });

})(window.angular);
